// import React, { useState } from "react";
// import { useParams } from "react-router-dom";
// import ProductGrid from "../SHOPE/Product.jsx";
// import { useNavigate } from "react-router-dom";
// import "./SinglePro.css";
// import { useLocation } from "react-router-dom";
// import { useContext } from "react";
// import { CartContext } from "../CartContext";

// const ProductDetail = () => {
//   const location = useLocation();
//   const [isAdded, setIsAdded] = useState(false);
//   const { id } = useParams(); // ✅ declare first

//   const product =
//     location.state || ProductGrid.find(p => p.id === Number(id)); // ✅ single declaration

//   const navigate = useNavigate(); // ❗ you forgot this earlier

//   const [qty, setQty] = useState(1);
//   const [selectedSize, setSelectedSize] = useState(null);

//   const [activeImg, setActiveImg] = useState(
//     product?.images?.[0] || product?.image
//   );

//   const { addToCart } = useContext(CartContext);

// const images =
//   product?.images?.length > 0
//     ? product.images
//     : product?.image
//     ? [product.image]
//     : [];
//       const increaseQty = () => setQty(qty + 1);
//   const decreaseQty = () => qty > 1 && setQty(qty - 1);

//   // ❗ Safety check
//   if (!product) {
//     return <h2 style={{ padding: "50px" }}>No product data found</h2>;
//   }


//   return (
//     <div className="sing-product-container">

//       {/* LEFT SECTION */}
//       <div className="sing-left-section">
//        <div className="sing-thumbnails">
//   {images.map((img, index) => (
//     <img
//       key={index}
//       src={img}
//       alt="thumb"
//       className={activeImg === img ? "active-thumb" : ""}
//       onClick={() => setActiveImg(img)}
//     />
//   ))}
// </div>

//         <div className="sing-main-image">
//           <img src={activeImg} alt={product.name} />
//         </div>
//       </div>

//       {/* RIGHT SECTION */}
//       <div className="sing-right-section">
//         <h1>{product.name}</h1>

//         <div className="sing-price">
//           <span className="sing-new-price">Rs {product.price}</span>
//           {product.oldPrice && (
//             <span className="sing-old-price">Rs {product.oldPrice}</span>
//           )}
//         </div>
// <div className="sing-rating">
//   {[...Array(5)].map((_, i) => {
//     let fillColor = "#E0E0E0"; 

//     if (i < Math.floor(product.rating)) {
//       fillColor = "#FFC700"; // full star
//     } else if (i < product.rating) {
//       fillColor = "#FFC700"; // (acts like full for now, can improve to half)
//     }

//     return (
//       <svg
//         key={i}
//         xmlns="http://www.w3.org/2000/svg"
//         width="16"
//         height="16"
//         viewBox="0 0 20 20"
//         fill="none"
//       >
//         <path
//           d="M10 1L13 7L19 7.75L14.88 12.37L16 19L10 16L4 19L5.13 12.37L1 7.75L7 7L10 1Z"
//           fill={fillColor}
//         />
//       </svg>
//     );
//   })}
//   <span className="rating-text"> {product.rating} Customer Review</span>
// </div>

//         {/* Color */}
//         <div className="sing-color-section">
//           <p>Color</p>
//           <div className="sing-colors">
//             <span className="sing-color purple"></span>
//             <span className="sing-color black"></span>
//             <span className="sing-color gold"></span>
//           </div>
//         </div>
//         {/* Size */}
// {product.category === "dress" && (
//   <div className="sing-size-section">
//     <p>Size</p>
//     <div className="sing-sizes">
//       {["XS", "S", "M", "L", "XL", "XXL", "XXXL"].map((size) => (
//         <span
//           key={size}
//           className={`sing-size ${selectedSize === size ? "active" : ""}`}
//           onClick={() => setSelectedSize(size)}
//         >
//           {size}
//         </span>
//       ))}
//     </div>
//   </div>
// )}

//         {/* Quantity */}
//         <div className="sing-cart-section">
//           <div className="sing-quantity">
//             <button onClick={decreaseQty}>-</button>
//             <span>{qty}</span>
//             <button onClick={increaseQty}>+</button>
//           </div>
// <button 
//   className="sing-add-to-cart" 
//   onClick={() => {
//     if (!isAdded) {
//       addToCart(product, qty);
//       setIsAdded(true);
//     } else {
//       navigate("/cart");
//     }
//   }}
// >
//   {isAdded ? "Go To Cart" : "Add To Cart"}
// </button>
//         </div>

//         <hr />

//         <div className="sing-product-info">
//           <p><b>SKU:</b> SS00{product.id}</p>
//           <p><b>Category:</b> Saree</p>
//           <p><b>Tags:</b> Fashion, Silk, Traditional</p>

//           <div className="sing-hshare">
//             <b>Share:</b>
//             <span><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="none">
//   <g clipPath="url(#clip0_444_4551)">
//     <path fillRule="evenodd" clipRule="evenodd" d="M0 10.0558C0 15.0275 3.61083 19.1617 8.33333 20V12.7775H5.83333V10H8.33333V7.7775C8.33333 5.2775 9.94417 3.88917 12.2225 3.88917C12.9442 3.88917 13.7225 4 14.4442 4.11083V6.66667H13.1667C11.9442 6.66667 11.6667 7.2775 11.6667 8.05583V10H14.3333L13.8892 12.7775H11.6667V20C16.3892 19.1617 20 15.0283 20 10.0558C20 4.525 15.5 0 10 0C4.5 0 0 4.525 0 10.0558Z" fill="black"/>
//   </g>
//   <defs>
//     <clipPath id="clip0_444_4551">
//       <rect width="20" height="20" fill="white"/>
//     </clipPath>
//   </defs>
// </svg></span>
//             <span><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="none">
//   <g clipPath="url(#clip0_444_4555)">
//     <path fillRule="evenodd" clipRule="evenodd" d="M0.833008 2.36504C0.833008 1.95882 0.99438 1.56923 1.28162 1.28199C1.56887 0.994748 1.95845 0.833376 2.36467 0.833376H17.633C17.8343 0.833047 18.0337 0.872428 18.2198 0.949265C18.4059 1.0261 18.575 1.13888 18.7174 1.28116C18.8598 1.42343 18.9728 1.5924 19.0498 1.77838C19.1269 1.96437 19.1665 2.16373 19.1663 2.36504V17.6334C19.1666 17.8347 19.1271 18.0341 19.0501 18.2202C18.9732 18.4063 18.8604 18.5754 18.718 18.7178C18.5757 18.8602 18.4067 18.9732 18.2206 19.0502C18.0346 19.1272 17.8352 19.1668 17.6338 19.1667H2.36467C2.16346 19.1667 1.96422 19.1271 1.77834 19.05C1.59245 18.973 1.42357 18.8601 1.28133 18.7178C1.13909 18.5755 1.02628 18.4065 0.94936 18.2206C0.872436 18.0347 0.832899 17.8354 0.833008 17.6342V2.36504ZM8.08967 7.82338H10.5722V9.07004C10.9305 8.35338 11.8472 7.70838 13.2247 7.70838C15.8655 7.70838 16.4913 9.13588 16.4913 11.755V16.6067H13.8188V12.3517C13.8188 10.86 13.4605 10.0184 12.5505 10.0184C11.288 10.0184 10.763 10.9259 10.763 12.3517V16.6067H8.08967V7.82338ZM3.50634 16.4925H6.17968V7.70838H3.50634V16.4917V16.4925ZM6.56218 4.84338C6.56722 5.07227 6.52648 5.29987 6.44237 5.5128C6.35826 5.72574 6.23247 5.91974 6.07237 6.0834C5.91227 6.24707 5.72109 6.3771 5.51005 6.46588C5.29902 6.55466 5.07237 6.60039 4.84343 6.60039C4.61448 6.60039 4.38783 6.55466 4.1768 6.46588C3.96576 6.3771 3.77458 6.24707 3.61448 6.0834C3.45438 5.91974 3.32859 5.72574 3.24448 5.5128C3.16036 5.29987 3.11963 5.07227 3.12467 4.84338C3.13457 4.39409 3.32 3.96654 3.64125 3.65228C3.9625 3.33803 4.39403 3.16206 4.84343 3.16206C5.29282 3.16206 5.72435 3.33803 6.0456 3.65228C6.36685 3.96654 6.55228 4.39409 6.56218 4.84338Z" fill="black"/>
//   </g>
//   <defs>
//     <clipPath id="clip0_444_4555">
//       <rect width="20" height="20" fill="white"/>
//     </clipPath>
//   </defs>
// </svg></span>
//             <span><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 25 25" fill="none">
//   <path d="M12.5 1.5625C6.45996 1.5625 1.5625 6.45996 1.5625 12.5C1.5625 18.54 6.45996 23.4375 12.5 23.4375C18.54 23.4375 23.4375 18.54 23.4375 12.5C23.4375 6.45996 18.54 1.5625 12.5 1.5625ZM17.7563 9.80713C17.7637 9.92188 17.7637 10.0415 17.7637 10.1587C17.7637 13.7427 15.0342 17.8711 10.0464 17.8711C8.5083 17.8711 7.08252 17.4243 5.88135 16.6553C6.10107 16.6797 6.31104 16.6895 6.53565 16.6895C7.80518 16.6895 8.97217 16.2598 9.90234 15.5322C8.71094 15.5078 7.70996 14.7266 7.36816 13.6523C7.78564 13.7134 8.16162 13.7134 8.59131 13.6035C7.97785 13.4789 7.42645 13.1457 7.0308 12.6606C6.63515 12.1755 6.41964 11.5684 6.4209 10.9424V10.9082C6.77979 11.1108 7.20215 11.2354 7.64404 11.2524C7.27256 11.0049 6.96792 10.6695 6.75711 10.276C6.5463 9.88244 6.43585 9.443 6.43555 8.99658C6.43555 8.49121 6.56738 8.02979 6.8042 7.62939C7.48511 8.46762 8.33479 9.15318 9.29801 9.64152C10.2612 10.1299 11.3164 10.41 12.395 10.4639C12.0117 8.62061 13.3887 7.12891 15.0439 7.12891C15.8252 7.12891 16.5283 7.45605 17.0239 7.9834C17.6367 7.86865 18.2227 7.63916 18.7451 7.33154C18.5425 7.95898 18.1177 8.48877 17.5537 8.82324C18.1006 8.76465 18.6279 8.61328 19.1162 8.40088C18.7476 8.94287 18.2861 9.42383 17.7563 9.80713Z" fill="black"/>
// </svg></span>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProductDetail;






import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE, FILE_BASE } from "../config";
import "./SinglePro.css";


const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();


  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);

  const [qty, setQty] = useState(1);
  const [selectedSize, setSelectedSize] = useState(null);
  const [isAdded, setIsAdded] = useState(false);

  const [activeImg, setActiveImg] = useState("");

  useEffect(() => {
    fetchProduct();
  }, [id]);

  const fetchProduct = async () => {
    try {
      const response = await axios.get(`${API_BASE}/products/${id}`);

      const data = response.data;

      setProduct(data);

      if (data.images?.length > 0) {
        const mainImage =
          data.images.find((x) => x.isMain)?.imageUrl ||
          data.images[0].imageUrl;

        setActiveImg(mainImage);
      }
    } catch (error) {
      console.error("Error fetching product:", error);
    } finally {
      setLoading(false);
    }
  };

  const increaseQty = () => setQty(qty + 1);

  const decreaseQty = () => {
    if (qty > 1) {
      setQty(qty - 1);
    }
  };

  if (loading) {
    return <h2 style={{ padding: "50px" }}>Loading...</h2>;
  }

  if (!product) {
    return <h2 style={{ padding: "50px" }}>Product not found</h2>;
  }

  return (
    <div className="sing-product-container">

      {/* LEFT SECTION */}
      <div className="sing-left-section">

        <div className="sing-thumbnails">
          {product.images?.map((img) => (
            <img
              key={img.id}
              src={img.imageUrl}
              alt="thumb"
              className={
                activeImg === img.imageUrl ? "active-thumb" : ""
              }
              onClick={() => setActiveImg(img.imageUrl)}
            />
          ))}
        </div>

        <div className="sing-main-image">
          <img src={activeImg} alt={product.name} />
        </div>
      </div>

      {/* RIGHT SECTION */}
      <div className="sing-right-section">

        <h1>{product.name}</h1>

        <div className="sing-price">
          <span className="sing-new-price">
            Rs {product.finalPrice}
          </span>

          {product.originalPrice && (
            <span className="sing-old-price">
              Rs {product.originalPrice}
            </span>
          )}
        </div>

        {/* Description */}
        <p className="sing-description">
          {product.description}
        </p>

        {/* Sizes */}
        {product.size && (
          <div className="sing-size-section">
            <p>Size</p>

            <div className="sing-sizes">
              {product.size.split(",").map((size) => (
                <span
                  key={size}
                  className={`sing-size ${selectedSize === size ? "active" : ""
                    }`}
                  onClick={() => setSelectedSize(size)}
                >
                  {size.trim()}
                </span>
              ))}
            </div>
          </div>
        )}

        {/* Quantity */}
        <div className="sing-cart-section">

          <div className="sing-quantity">
            <button onClick={decreaseQty}>-</button>

            <span>{qty}</span>

            <button onClick={increaseQty}>+</button>
          </div>

          <button
            className="sing-add-to-cart"
            onClick={async () => {

              try {

                const token = sessionStorage.getItem("token");

                if (!token) {
                  navigate("/login");
                  return;
                }

                if (!isAdded) {

                  await axios.post(
                    `${API_BASE}/cart/add`,
                    {
                      productId: product.id,
                      quantity: qty,
                    },
                    {
                      headers: {
                        Authorization: `Bearer ${token}`,
                      },
                    }
                  );

                  setIsAdded(true);

                } else {
                  navigate("/cart");
                }

              } catch (error) {

                console.error("Add to cart error:", error);

                alert(
                  error?.response?.data ||
                  "Failed to add to cart"
                );
              }
            }}
          >
            {isAdded ? "Go To Cart" : "Add To Cart"}
          </button>
        </div>

        <hr />

        {/* Product Info */}
        <div className="sing-product-info">

          <p>
            <b>SKU:</b> {product.sku}
          </p>

          <p>
            <b>Category:</b> {product.category?.name}
          </p>

          <p>
            <b>Material:</b> {product.material}
          </p>

          <p>
            <b>Weight:</b> {product.weight} gm
          </p>

          <p>
            <b>Status:</b> {product.status}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;